module.exports = __webpack_public_path__ + "img/index-2.3d648580.jpg";